import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FeatureTogglingDirective } from '@banyan/commons/directives/feature-toggling.directive';
import { AccountService } from '@banyan/features/account/services/account.service';

@Component({
  selector: 'app-admin-navbar',
  templateUrl: './admin-navbar.component.html',
  styleUrls: ['./admin-navbar.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,
    MatIconModule,
    FeatureTogglingDirective,
  ],
})
export class AdminNavbarComponent {
  accountService = inject(AccountService);

  logout() {
    this.accountService.logout();
  }
}
